module.exports = __webpack_public_path__ + "media/images/athletes/3524-61d635aa313475af3b346a52c82ab7ab.png";